// extracted by mini-css-extract-plugin
module.exports = {"screenReaderText":"BadgeIcon_screenReaderText__3mv9z","badgeIcon":"BadgeIcon_badgeIcon__Gu1t2","badge":"BadgeIcon_badge__2-glS"};